const CAMERA_TIMEOUT_IN_MS = 60000

export { CAMERA_TIMEOUT_IN_MS }
